const switchColor = () => {
  let root = document.documentElement;
  root.addEventListener("click", () => {
    root.style.setProperty('--green-light', localStorage.getItem('__user-area') === 'med' ? '#fcb100' : '#05be90');
  });
}

export default switchColor;